<div class="actions">
    <div [formGroup]="form" class="search-bar-wrapper">
        <div class="search-bar">
            <mat-icon class="leading-icon" aria-hidden="true">search</mat-icon>
            <input
                type="text"
                class="search-input"
                formControlName="searchControl"
                placeholder="Search by name, fin number, branch..."
                aria-label="Search clients"
                (keydown.enter)="onEnterPressed()" />
            <button
                type="button"
                class="clear-btn"
                *ngIf="clearIconVisible"
                (click)="onClearSearch()"
                title="Clear search"
                aria-label="Clear search">
                <mat-icon>close</mat-icon>
            </button>
            <button
                type="button"
                class="search-btn"
                (click)="onSearchIconClick()">
                Search
            </button>
        </div>
    </div>
    <app-lbn-action-button label="New Client" position="right"
                (click)="clickEvent('new')"></app-lbn-action-button>
</div>